<template>
    <div class="p-feed" :class="{ 'l-feed': fill }">
        <div class="p-feed__header">
            <span class="p-feed__title">
                <v-icon small color="primary">mdi-format-list-bulleted</v-icon>Feed
                <span class="p-feed__count">{{ rows.length }}</span>
            </span>
            <v-text-field
                :value="jersey"
                class="p-feed__filter"
                placeholder="Jersey #"
                outlined
                dense
                hide-details
                clearable
                prepend-inner-icon="mdi-magnify"
                @input="$emit('update:jersey', $event)"
            />
            <v-menu offset-y left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" title="More" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item @click="$emit('delete-all')">
                        <v-list-item-icon class="mr-3">
                            <v-icon small color="red darken-1">mdi-delete-sweep-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="red--text text--darken-1">Delete whole feed</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
        <div class="p-feed__time-filter">
            <v-btn-toggle :value="timeOp" mandatory dense class="p-feed__ops" @change="$emit('update:timeOp', $event)">
                <v-btn small value="=" title="At this time">=</v-btn>
                <v-btn small value=">=" title="At or after this time">≥</v-btn>
                <v-btn small value="<=" title="At or before this time">≤</v-btn>
            </v-btn-toggle>
            <v-text-field
                :value="time"
                class="p-feed__time-input"
                placeholder="Time mm:ss"
                outlined
                dense
                hide-details
                clearable
                prepend-inner-icon="mdi-clock-outline"
                :error="timeInvalid"
                @input="$emit('update:time', $event)"
            />
        </div>
        <div v-if="!rows.length" class="p-feed__empty">
            {{ filtersActive ? 'No events match the filters' : 'No events yet' }}
        </div>
        <div v-else :class="{ 'l-feed__scroll': fill }">
            <!-- fill: no height prop, v-virtual-scroll reads "100%" as 100px; it measures the CSS height instead -->
            <v-virtual-scroll
                :items="rows"
                :item-height="44"
                :height="fill ? undefined : height"
                bench="10"
            >
                <template v-slot:default="{ item }">
                    <div class="p-feed__item">
                        <span class="p-feed__time">{{ item.timestamp }}</span>
                        <span class="p-feed__team" :style="item.teamStyle">
                            <v-img v-if="item.logo" contain width="20" height="20" :src="item.logo" />
                            <v-icon v-else small color="primary darken-1">mdi-flag-checkered</v-icon>
                        </span>
                        <span class="p-feed__text">{{ item.text }}</span>
                        <v-icon v-if="item.status === 'stop'" small color="red" title="Subbed out">mdi-arrow-left</v-icon>
                        <v-icon v-else-if="item.status === 'begin'" small color="green" title="Subbed in">mdi-arrow-right</v-icon>
                        <v-icon v-else-if="item.status === 'ended'" small color="primary darken-1" title="Delete it to open the match again">mdi-flag-checkered</v-icon>
                        <!-- advanced stats of a shot: filled in (teal) or still to fill in -->
                        <v-btn
                            v-if="item.shot"
                            icon
                            small
                            class="p-feed__details"
                            :title="item.detailsText ? `Advanced: ${item.detailsText}` : 'Add advanced stats'"
                            @click="$emit('edit-shot', item.logId)"
                        >
                            <v-icon small :color="item.detailsText ? 'primary darken-1' : 'grey'">{{ item.detailsText ? 'mdi-tag' : 'mdi-tag-plus-outline' }}</v-icon>
                        </v-btn>
                        <v-btn icon small class="p-feed__delete" title="Delete event" @click="$emit('delete-log', item.logId)">
                            <v-icon small color="grey">mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </div>
                </template>
            </v-virtual-scroll>
        </div>
    </div>
</template>

<script>
    // Match feed with jersey + time filters. rows: [{ logId, timestamp, text, logo, teamStyle, status }]
    // fill = take the height left in the parent (landscape centre column) instead of a fixed height
    export default {
        name: 'StatsFeed',
        props: {
            rows: {
                type: Array,
                default: () => []
            },
            jersey: {
                type: String,
                default: null
            },
            timeOp: {
                type: String,
                default: '='
            },
            time: {
                type: String,
                default: null
            },
            timeInvalid: {
                type: Boolean,
                default: false
            },
            filtersActive: {
                type: Boolean,
                default: false
            },
            fill: {
                type: Boolean,
                default: false
            },
            height: {
                type: [Number, String],
                default: 264
            }
        }
    }
</script>
